import {
    post,
    get,
    put,
    del
} from "./http"

const user = {
    // 获取图形验证码
    getCaptcha(params) {
        return get("captcha", params)
    },
    // 获取短信验证码
    getMessageCode(params) {
        return get("messageCode", params)
    },

    // 用户注册
    register(params) {
        return post("register", params)
    },
    // 用户登录
    login(params) {
        return post("login", params)
    },
    // 获取用户信息
    getInfo() {
        return get("getInfo")
    },
    // 找回密码
    findPassword(params) {
        return post("forget", params)
    },
    changPassword(params) {
        return put("profile/updatePwd", params)
    },
    // 退出登录
    logout() {
        return post("logout")
    },

    // 提交实名认证
    identitySub(params) {
        return post("client/identity", params)
    },
    // 获取认证资料
    Getidentity(params) {
        return get("client/identity", params)
    },
    // 获取认证资料
    Getidentity2() {
        return get("client/identity2")
    },
    // 行业类型
    getIndustries() {
        return get("industries")
    },
    // 获取用户注册手机号
    getuser() {
        return get("profile")
    },
    // 获取下落地
    getAreaList(params) {
        return get("agents",params)
    },
    // ====通讯录管理=====

    // 新增通讯录分组
    addgroup(params) {
        return post("client/address-book/group", params)
    },
    // 编辑通讯录分组
    editgroup(params) {
        return put("client/address-book/group", params)
    },
    // 删除通讯录分组
    delgroup(id) {
        return del("client/address-book/group/" + id)
    },
    // 通讯录列表
    grouplist() {
        return get("client/address-book/group")
    },
    // 新增联系人
    addcontacts(params) {
        return post("client/address-book", params)
    },
    // 修改联系人
    editcontacts(id, params) {
        return put("client/address-book/" + id, params)
    },
    // 删除联系人
    delcontacts(groupId, contactId) {
        return del(`client/address-book/group/${groupId}/${contactId}`)
    },
    // 删除整个分组的联系人
    delGroupContacts(groupId) {
        return del(`client/address-book/group-id/${groupId}`)
    },
    // 联系人列表
    contactsList(id, params) {
        return get("client/address-book/group/" + id, params)
    },
    // 导入
    importfile(params) {
        return post("client/address-book/import", params)
    },
    // 导入完成检查
    importCheck(params) {
        return get(`client/address-book/import/${params.md5}`)
    },
    //充值记录
    rechargeRecords(params) {
        return get("client/recharge-order/list", params)
    },
    //修改手机号码
    changePhone(params) {
        return put("profile/updateTel", params)
    },
    //发送短信验证码
    sendSmsCode(params, type) {
        return get("getTelCode", params)
    },
    sendResetCode(params) {
        return get("getResetCode", params)
    },
    // 修改资料时，验证码
    getModifyCode(params) {
        return get("getModifyCode", params)
    },
    isExistPhone(params) {
        return get("exist", params)
    },
    isExistPhoneForget(data) {
        return get("system/user/mobile/" + data + "/exists")
    },
    avatar(params) {
        return post("profile/avatar", params)
    },
    // 导出充值记录
    exportExcel(params) {
        return post("client/recharge-order/export", params)
    },
    // 上传文件
    upload(params) {
        return post("common/upload", params)
    },
    //新增子账号
    addChildUser(params){
        return post('system/user/addChildUser',params)
    },
    //充值
    chongzhi(params){
      return get('system/user/addChongzhi',params)
    },
    //查看子账号列表
    childList(params){
      return get('system/user/childList',params)
    },
    editChlidUser(params){
      return get('system/user/editChildUser',params)
    },
}

export default user